import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RecoilRoot } from 'recoil';
import "animate.css"
import '@/styles/reset.less'
import '@/styles/global.less'
import './index.less'
import App from './App.jsx'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <RecoilRoot>
        <App />
    </RecoilRoot>
  </StrictMode>,
)